import React from 'react'
import { Button, Icon, Input, Spin } from 'antd'
import PropTypes from 'prop-types'
import { getDirectionClassName, getLanguageDirection } from './storyDirection'
import './TranslationWorkspace.scss'

const TranslationWorkspace = ({
  existingStory,
  translatedStory,
  translatedStoryLanguage,
  translatedStoryLanguageLabel,
  languageControl,
  isLoading,
  onSourceChange,
  onTranslate,
  onReview,
  onAddStory
}) => {
  const resultDirection = getLanguageDirection(translatedStoryLanguage)
  const resultDirectionClass = getDirectionClassName(resultDirection)
  const hasExistingStory = Boolean(String(existingStory || '').trim())

  return (
    <div className="translation-workspace">
      <div className="translation-workspace__grid">
        <div className="translation-workspace__action-step">
          <div className="translation-workspace__action-copy">
            <div className="translation-workspace__action-title">
              <Icon type="swap" /> Generate Translation
            </div>
            <div className="translation-workspace__action-text">
              {hasExistingStory
                ? 'Choose a language, then translate.'
                : 'Add a story before generating a translation.'}
            </div>
          </div>
          <div className="translation-workspace__action-controls">
            <div className="translation-workspace__language-control">
              {languageControl}
            </div>
            <Button
              className="quick-translate-btn"
              type="primary"
              onClick={onTranslate}
              loading={isLoading}
              disabled={!hasExistingStory}
              icon='thunderbolt'
            >
              Translate
            </Button>
          </div>
        </div>
        <div className="translation-panel translation-panel--source" dir="auto">
          <div className="translation-panel__header">
            <div className="translation-panel__header-main">
              <span className="translation-panel__section-icon">
                <Icon type="file-text" />
              </span>
              <span className="title">Original Story</span>
            </div>
          </div>
          <div className="translation-panel__content translation-panel__content--editable">
            <Input.TextArea
              value={existingStory}
              onChange={event => onSourceChange(event.target.value)}
              className="translation-panel__source-editor"
              aria-label="Original story"
              placeholder="Enter or edit the story you want to translate."
              autoSize={false}
            />
          </div>
        </div>



        <div className="translation-panel translation-panel--result">
          <div className="translation-panel__header">
            <div className="translation-panel__header-main">
              <span className="translation-panel__section-icon translation-panel__section-icon--accent">
                <Icon type="book" />
              </span>
              <span className="title">Translated Story</span>
            </div>
            {translatedStory && translatedStoryLanguage && (
              <span className="translation-panel__pill">
                {translatedStoryLanguageLabel}
              </span>
            )}
          </div>

          {isLoading ? (
            <div className="translation-state translation-state--loading">
              <Spin size="large" />
              <div className="translation-state__title">Translating story...</div>
              <div className="translation-state__text">
                We&apos;re generating the translated version now.
              </div>
            </div>
          ) : translatedStory ? (
            <div
              className={`translation-panel__result-body ${resultDirectionClass}`}
              dir={resultDirection}
            >
              <div className="translation-panel__content translation-panel__content--result">
                {translatedStory}
              </div>
              <div className="translation-panel__footer">
                <Button
                  type="default"
                  className="review-edit-btn"
                  onClick={onReview}
                >
                  <Icon type="edit" /> Review & Edit
                </Button>
                <Button
                  type="primary"
                  className="add-to-video-btn"
                  onClick={onAddStory}
                >
                  <Icon type="thunderbolt" /> Add to Video
                </Button>
              </div>
            </div>
          ) : (
            <div className="translation-state translation-state--empty">
              <Icon type="translation" />
              <div className="translation-state__title">
                {hasExistingStory ? 'Ready to translate' : 'Story required'}
              </div>
              <div className="translation-state__text">
                {hasExistingStory
                  ? 'Generate a translated version to preview it here.'
                  : 'Add a story before choosing a translation language.'}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

TranslationWorkspace.propTypes = {
  existingStory: PropTypes.string,
  translatedStory: PropTypes.string,
  translatedStoryLanguage: PropTypes.string,
  translatedStoryLanguageLabel: PropTypes.string,
  languageControl: PropTypes.node,
  isLoading: PropTypes.bool,
  onSourceChange: PropTypes.func,
  onTranslate: PropTypes.func,
  onReview: PropTypes.func,
  onAddStory: PropTypes.func
}

TranslationWorkspace.defaultProps = {
  existingStory: '',
  translatedStory: '',
  translatedStoryLanguage: '',
  translatedStoryLanguageLabel: 'English',
  languageControl: null,
  isLoading: false,
  onSourceChange: () => {},
  onTranslate: null,
  onReview: null,
  onAddStory: null
}

export default TranslationWorkspace
